import React from 'react';
import {
  mergeClasses,
  makeStyles,
  shorthands,
  tokens,
} from '@fluentui/react-components';

const usePageTemplateStyles = makeStyles({
  pageLayout: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  },
  mainContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: tokens.colorNeutralBackground2,
    ...shorthands.flex(1),
    ...shorthands.overflow('auto'),
    ...shorthands.padding('16px', '24px'),
  },
  footerContainer: {},
});

interface PageTemplateProps {
  items: {
    Blocker: React.FC;
    TitleBar: React.FC;
    Content: React.FC;
    Footer: React.FC;
    CancelDialog: React.FC;
    ConfirmDialog: React.FC;
  };
}

export const PageTemplate: React.FC<PageTemplateProps> = ({ items }) => {
  const {
    Blocker = React.Fragment,
    TitleBar,
    Content,
    Footer,
    CancelDialog,
    ConfirmDialog,
  } = items;
  const classes = usePageTemplateStyles();

  return (
    <div className={mergeClasses('page-layout', classes.pageLayout)}>
      <Blocker>
        <div className={classes.mainContainer}>
          {TitleBar && <TitleBar />}
          <div className={classes.contentContainer}>
            <Content />
          </div>
          {Footer
            && (
            <div className={mergeClasses('footer-container', classes.footerContainer)}>
              <Footer />
            </div>
            )}
        </div>
      </Blocker>
      {CancelDialog && <CancelDialog />}
      {ConfirmDialog && <ConfirmDialog />}
    </div>
  );
};
